'use client';
import styles from './categories.module.scss';
import { MdArrowBackIos } from 'react-icons/md';
import { CategoryType, CategoryVolumeEnum, PaginationType, ResponseType, ThemeEnum } from 'types';
import { COLORS } from 'utilities';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'context';
import { CategoryBreadcrumbComp, MobileHeaderComp } from 'components';
import { API } from 'data/api';
import { catIconData } from 'data/categoryIcon';
import { PATH } from 'data/path';
import { TbArrowRight, TbSearch } from 'react-icons/tb';
import { RestAPI, useRealTimeState } from 'scripts';
import { Button, ConfigProvider, Empty, Input, Result, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';

function PostFormCategoriesComp() {
    // const bulkText = 'عمده فروشی';
    const { theme } = useContext(GlobalContext);
    const nav = useNavigate();
    const selectedCategory = useRealTimeState<CategoryType<'list'> | undefined>(undefined);
    const categories = useRealTimeState<ResponseType<PaginationType<CategoryType<'list'>>> | undefined>(undefined);
    const mode = useRealTimeState<'single' | 'bulk'>('single');
    const [search, setSearch] = useState('');

    useEffect(() => {
        RestAPI.get<PaginationType<CategoryType<'list'>>>(API.category.list, {
            page_size: 450,
            ordering: '-order',
        })
            .then(categories.set)
            .catch(categories.set);
        window.addEventListener('popstate', backHandler);
        return () => {
            window.removeEventListener('popstate', backHandler);
        };
    }, []);

    const backHandler = () => {
        if (selectedCategory.get()) {
            const parent = categories.get()?.data.data.find((i) => i.id === selectedCategory.get()?.parent);
            selectedCategory.set(parent);
        } else if (mode.get() === 'bulk') mode.set('single');
    };

    const categoryCard = (title: string, icon?: string) => {
        const Icon = catIconData.find((i) => i.key === icon);
        return (
            <div className={`${styles['categories-card']} d-flex center-content-y justify-content-between pointer`}>
                <div className="d-flex center-content-y g-1">
                    {Icon ? <Icon.icon size={20} className="t-primary" /> : null}
                    <p className="t-400 t-p2 t-l-black1">{title}</p>
                </div>
                <MdArrowBackIos size={16} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3} />
            </div>
        );
    };

    const getParents = (list: CategoryType<'list'>[], category?: CategoryType<'list'>) => {
        if (!category || !category.parent) return list;
        const parentCat = categories.dep?.data.data.find((i) => i.id === category.parent);
        if (parentCat) return getParents([parentCat, ...list], parentCat);
        else return list;
    };

    // search categories, sort by title, then by bread crumb length
    const searchedCategories = categories.dep?.data.data
        .filter((i) => (search.length ? i.title.includes(search) : false))
        .sort((a, b) => a.title.localeCompare(b.title))
        .sort((a, b) => getParents([a], a).length - getParents([b], b).length)
        .sort((a, b) => (b.order ?? 0) - (a.order ?? 0));

    // const onBulkClick = () => {
    //     setSearch('');
    //     mode.set('bulk');
    //     const url = new URL(window.location.href);
    //     url.searchParams.set('mode', 'bulk');
    //     window.history.pushState({}, '', url.href);
    // };

    const onCategorySelect = (category: CategoryType<'list'>) => {
        const parent = categories.dep?.data.data.find((i) => i.parent === category.id);
        if (parent) {
            setSearch('');
            selectedCategory.set(category);
            const url = new URL(window.location.href);
            url.searchParams.set('cat', category.id.toString());
            if (category.volume === CategoryVolumeEnum.multi) {
                mode.set('bulk');
                url.searchParams.set('mode', 'bulk');
            }
            window.history.pushState({}, '', url.href);
        } else nav(PATH.panel.addPost.locations(category.slug).path);
    };

    if (!categories.dep)
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin size="small" />
            </div>
        );

    if (!categories.dep?.data)
        return (
            <Result
                status="error"
                title="خطا"
                subTitle="خطایی رخ داده است. لطفا کمی بعد مجددا تلاش نمایید"
                extra={[
                    <Button type="primary" key="console">
                        بازگشت
                    </Button>,
                    <Button key="buy">تلاش مجدد</Button>,
                ]}
            ></Result>
        );

    return (
        <>
            <MobileHeaderComp title={'انتخاب دسته بندی آگهی جدید'} onIconClick={() => nav(-1)} />
            <div className={`pt-1 ${styles['search-container']}`}>
                <ConfigProvider
                    theme={{
                        components: {
                            Input: {
                                activeBorderColor: `${COLORS.gray2} !important`,
                                hoverBorderColor: `${COLORS.gray2} !important`,
                            },
                        },
                    }}
                >
                    <Input
                        placeholder="جستجو در همه دسته ها"
                        className={`${styles['search-input']}`}
                        allowClear
                        onChange={(e) => setSearch(e.target.value)}
                        onClear={() => setSearch('')}
                        value={search}
                        prefix={
                            <TbSearch
                                size={28}
                                className={`pl-1 pointer ${theme === ThemeEnum.light ? 't-black1' : 't-gray2'}`}
                            />
                        }
                    />
                </ConfigProvider>
            </div>
            <div className="flex-column g-2 pt-2">
                {selectedCategory.dep ? (
                    <div
                        className={`${styles['categories-back']} d-flex center-content-y pointer`}
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        <TbArrowRight size={20} />
                        <p className="t-400 t-p2 t-l-black1">{selectedCategory.dep.title}</p>
                    </div>
                ) : null}
                {/* {(!search.length || bulkText.includes(search)) && mode.dep === 'bulk' && !selectedCategory.dep ? (
                    <div
                        className={`${styles['categories-back']} d-flex center-content-y pointer`}
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        <TbArrowRight size={20} />
                        <p className="t-400 t-p2 t-l-black1">{bulkText}</p>
                    </div>
                ) : null}
                {(!search.length || bulkText.includes(search)) && !selectedCategory.dep && mode.dep === 'single' ? (
                    <div className={styles['categories-link']} onClick={onBulkClick}>
                        <div
                            className={`${styles['categories-card']} d-flex center-content-y justify-content-between pointer`}
                        >
                            <div className="d-flex center-content-y g-1">
                                <TbCategory size={20} className="t-primary" />
                                <p className="t-400 t-p2 t-l-black1">{bulkText}</p>
                            </div>
                            <MdArrowBackIos
                                size={16}
                                color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3}
                            />
                        </div>
                    </div>
                ) : null} */}
                {search.length ? (
                    searchedCategories?.length ? (
                        <div className={`${styles['categories-link']} flex-column g-2`}>
                            {search.length
                                ? searchedCategories.map((i) => (
                                      <CategoryBreadcrumbComp
                                          list={getParents([i], i)}
                                          key={i.id}
                                          onClick={onCategorySelect}
                                      />
                                  ))
                                : null}
                        </div>
                    ) : (
                        <Empty
                            className="flex-column center-content"
                            description="دسته ای با عبارت مورد نظر شما یافت نشد."
                        />
                    )
                ) : null}
                {!search.length
                    ? categories.dep.data.data
                          .filter((i) =>
                              mode.dep === 'single'
                                  ? i.volume !== CategoryVolumeEnum.multi
                                  : i.volume !== CategoryVolumeEnum.single,
                          )
                          .filter((i) => (selectedCategory.dep ? i.parent === selectedCategory.dep.id : !i.parent))
                          .sort((a, b) => (b.order ?? 0) - (a.order ?? 0))
                          .map((category) => (
                              <div
                                  key={category.id}
                                  className={styles['categories-link']}
                                  onClick={() => onCategorySelect(category)}
                              >
                                  {categoryCard(category.title, category.icon)}
                              </div>
                          ))
                    : null}
            </div>
        </>
    );
}

export default PostFormCategoriesComp;
